module.exports = __webpack_public_path__ + "components/MapControl/svg/Restauracja_kawiarnia_bar.svg?96996a24";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Restauracja_kawiarnia_bar.svg
// module id = 1988
// module chunks = 0